export default __webpack_public_path__ + "static/media/qq-circle.5b219bb6.svg";